import { render, staticRenderFns } from "./InspectionStandard.vue?vue&type=template&id=6c721da2&"
import script from "./InspectionStandard.vue?vue&type=script&lang=js&"
export * from "./InspectionStandard.vue?vue&type=script&lang=js&"
import style0 from "./InspectionStandard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports